import React, { createContext, useContext, ReactNode } from "react";

interface ExperimentContextValue {
    /** The PostHog distinct ID used for experiment evaluation. */
    distinctId: string;
    /** PostHog group associations used for group-scoped experiments. */
    groups?: Record<string, string>;
}

const ExperimentContext = createContext<ExperimentContextValue>({
    distinctId: "",
    groups: undefined
});

/**
 * Provides the experiment distinctId and groups to all descendant useExperiment() hooks.
 *
 * Each app wires this once at the root:
 * - Core app: reads user.uid + currentWorkspaceId from globalStore
 * - Rapid: reads user.uid + currentWorkspace.id from rapid's auth/store
 */
export function ExperimentProvider({
    distinctId,
    groups,
    children
}: {
    distinctId: string;
    groups?: Record<string, string>;
    children: ReactNode;
}) {
    return (
        <ExperimentContext.Provider value={{ distinctId, groups }}>
            {children}
        </ExperimentContext.Provider>
    );
}

export function useExperimentContext(): ExperimentContextValue {
    return useContext(ExperimentContext);
}
